module.exports = __webpack_public_path__ + "assets/img/ie.6dc2c4b7.svg";